module.exports = __webpack_public_path__ + "static/media/liveroom-setting-ban.d6f2dee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroomSetting/liveroom-setting-ban.png
// module id = 1968
// module chunks = 6